export default __webpack_public_path__ + "static/media/NewLogo.261a1d25.jpg";